'use strict';
(function () {
  angular.module('pentaApp').factory('holiday.resource', service);

  service.$inject = ['$resource'];
  function service($resource) {
    return $resource('/progressiveApp/api/holiday', null, { query: { isArray: true, cache: true } });
  }
})();